import { Button } from "@mui/material";
import PropTypes from "prop-types";
import { useState } from "react";
import Icons from "../components/icon";
import { useAppServices } from "../../../../hook/services";

function ModalComponent({ open, onClose, item, handleRefresh }) {
  const AppService = useAppServices();

  const deleteassistant = async (item) => {
    const { response } = await AppService.assistant.Delete({
      query: `_id=${item._id}&assistant_id=${item.assistant_id}`,
      toaster: true
    });
    if (response) {
      onClose();
      handleRefresh();
    }

  }
  return (<>

    {open &&
      <div className="modal-zz-confirm text-left">

        <div className="scrollable-modal-content bg-white  rounded" style={{ position: "relative" }}>

          <span style={{ position: "absolute", right: "10px", top: "5px", cursor: "pointer" }} onClick={onClose}>X</span>
          <div>
            <p>Are you sure you want to delete {`"${item?.assistant_name}"`} </p>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }} >
              <Button variant="outlined" color="secondary" size="small"

                sx={{ mt: 4, mb: 1, mr: 2 }}
                onClick={() => deleteassistant(item)}
                fullWidth
              >
                Yes
              </Button>
              <Button variant="outlined" color="error" size="small"
                sx={{ mt: 4, mb: 1, ml: 2 }}
                onClick={onClose}
                fullWidth
              >
                Cancel
              </Button>
            </div>
          </div>
        </div>
      </div>
    }
  </>
  );
}
ModalComponent.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  handleRefresh: PropTypes.func,
  products: PropTypes.array,
  apps: PropTypes.array,
};
function Modal({ item, handleRefresh }) {
  const [openAddMember, setOpenAddMember] = useState(false);

  return (
    <>
      <span
        onClick={() => setOpenAddMember(item)}
        className="text-[12px] flex !justify-between items-center w-full"
        style={{ padding: "5px 0px", cursor: "pointer" }}>

        <span >Delete</span>
        <Icons id="delete" />
      </span>

      <ModalComponent
        open={openAddMember}
        onClose={() => setOpenAddMember(false)}
        item={item}
        handleRefresh={handleRefresh}
      />

    </>
  );
}
Modal.propTypes = {
  products: PropTypes.array,
  handleRefresh: PropTypes.func,
  apps: PropTypes.array,
};
export default Modal;
